import { CodeNameModel } from 'components/common/types';
import AsyncSelect from 'lib/AsyncSelect';
import { SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import usePendoTracking from 'customHooks/usePendoTracking';
import { useLoadLookup } from '../useLoadLookup';
import { FilterProductCategoryLookupProps } from './FilterProductCategoryLookup.types';

const FilterProductCategoryLookup: React.FC<FilterProductCategoryLookupProps> = ({
  changeFilters,
  productCategory,
}) => {
  const { onLoadProductCategory } = useLoadLookup();

  const { getPendoDataId } = usePendoTracking(window.location.pathname);

  const handleSelectProductCategoryLookup: SelectHandler<CodeNameModel> = (_, value: CodeNameModel): void => {
    changeFilters({ productCategory: value });
  };

  return (
    <AsyncSelect
      name="productCategory"
      loadData={onLoadProductCategory}
      placeholder="Select product category"
      selectedValue={productCategory}
      onSelect={handleSelectProductCategoryLookup}
      dataTestId="productCategories-filter"
      textKey="name"
      dataPendoId={getPendoDataId('Product category filter')}
    />
  );
};

export default FilterProductCategoryLookup;
